import { Card, Placeholder } from "react-bootstrap";

export const SkSmallCard = () => {
  return (
    <Placeholder as={Card.Text} animation="glow">
      <Placeholder xs={7} />
    </Placeholder>
  );
};